import React, { useState, useEffect } from 'react';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import { useSelector, useDispatch } from 'react-redux';
import * as _ser from '../../../_redux/_services/ClientsSlice';
import GetJobId from '../../../_utilities/GetJobId';
import { GetTimeZone } from '../../../_utilities/GetTimeZone';
import { scrollToElement } from '../../../_utilities/scrollHelper';

const initalState = { data: null, message: '', isloader: true };

const ClientsAuditlogging = () => {
  const [AuditlogData, setAuditlogData] = useState([]);
  const [config, setConfig] = useState(configuration);

  const dispatch = useDispatch();
  const getJobId = GetJobId();

  const AuditlogResponse = useSelector(
    (state) => state.GetClientsComments.data
  );

  useEffect(() => {
    if (getJobId !== null) {
      Getdata();
    }
  }, [getJobId]);

  const Getdata = async () => {
    let obj = {
      type: 'clients',
      typeId: getJobId,
    };
    dispatch(_ser.getClientsCommentsAsync(obj));
  };

  useEffect(() => {
    if (AuditlogResponse !== null && AuditlogResponse.length > 0) {
      let auditlog = JSON.parse(JSON.stringify(AuditlogResponse));
      auditlog.forEach((item) => {
        item.createdAt = GetTimeZone(item.createdAt);
      });
      setAuditlogData(auditlog);
      let configObj = JSON.parse(JSON.stringify(config));
      configObj.totalRecords = AuditlogResponse.length;
      setConfig(configObj);
      dispatch(_ser.getClientsCommentsStartReducer(initalState));
    }
  }, [AuditlogResponse]);

  // for dynamic component received props
  const onReceiveActionHandler = (type, object) => {
    if (type === 'pageRange') {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
        currentPage: 1,
      });
    } else if (type === 'scroll') {
      scrollToElement('auditLog');
    }
  };

  return (
    <>
      {/* <h1 style={{ fontWeight: 300, lineHeight: 1.2, textAlign: "center", margin: "60px 0", fontSize: "3rem" }}>Clients Audit logging</h1> */}
      <div style={{ padding: '0 0px', marginBottom: '80px' }}>
        <div style={{ background: '#fff', padding: '25px 15px' }} id="auditLog">
          {/* for dynamic Table */}
          {AuditlogData === null ||
            (AuditlogData.length === 0 && (
              <DynamicTable
                config={config}
                data={AuditlogData}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                actions={actionsList}
                filterValue={''}
                noDataText={'No Audit logs found'}
                addModel={addNewModel}
                searchKeyWord="Search by Actions"
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            ))}
          {AuditlogData && AuditlogData.length > 0 && (
            <DynamicTable
              config={config}
              data={AuditlogData}
              colmns={columnsData}
              actionDropdown={actionsDropdownData}
              actions={actionsList}
              filterValue={''}
              noDataText={'No Audit logs found'}
              addModel={addNewModel}
              searchKeyWord="Search by Actions"
              onReceiveActionProps={(type, obj) =>
                onReceiveActionHandler(type, obj)
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ClientsAuditlogging;

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 10,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ['Delete'];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: 'Name',
    mappingName: 'fullName',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center',
    width: '25%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 2,
    displayName: 'Action Performed',
    mappingName: 'action',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center ',
    width: '25%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 3,
    displayName: 'Date and Time',
    mappingName: 'createdAt',
    theadClass: 'dynatableheadtext text-center ',
    tbodyClass: 'dynatablebodytext text-center',
    width: '25%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 4,
    displayName: 'Comments',
    mappingName: 'comments',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center',
    width: '25%',
    isEdit: false,
    nagigate: '',
  },
];

const addNewModel = {
  url: '',
  displayName: '',
};
